import React from 'react';
import { Phoenix } from './Phoenix';

const phoenix = new Phoenix(window.location.hostname !== "localhost");
const PhoenixContext = React.createContext(phoenix);
export const PhoenixProvider = PhoenixContext.Provider;
export { phoenix }
export default PhoenixContext;